// NOTICE: KAPTION-INTEGRATION
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import kaptionResponsePoliciesAPI from '../../api/kaptionResponsePolicies';

const state = {
  records: [],
  metrics: {},
  missed: { data: [], meta: {} },
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    fetchingMetrics: false,
    fetchingMissed: false,
  },
};

export const getters = {
  getPolicies(_state) {
    return _state.records.sort((a, b) => b.id - a.id);
  },
  getPolicy: _state => id => {
    return _state.records.find(policy => policy.id === Number(id));
  },
  getPoliciesByMode: _state => mode => {
    return _state.records.filter(p => p.mode === mode);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMetrics(_state) {
    return _state.metrics;
  },
  getMissed(_state) {
    return _state.missed;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
      fetchingList: true,
    });
    try {
      const response = await kaptionResponsePoliciesAPI.getAll();
      commit(types.default.SET_KAPTION_RESPONSE_POLICIES, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  async create({ commit }, params) {
    commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
      creatingItem: true,
    });
    try {
      const response = await kaptionResponsePoliciesAPI.create(params);
      commit(types.default.ADD_KAPTION_RESPONSE_POLICY, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
      updatingItem: true,
    });
    try {
      const response = await kaptionResponsePoliciesAPI.update(id, updateObj);
      commit(types.default.UPDATE_KAPTION_RESPONSE_POLICY, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  async getMetrics({ commit }, params = {}) {
    commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
      fetchingMetrics: true,
    });
    try {
      const response = await kaptionResponsePoliciesAPI.getMetrics(params);
      commit(types.default.SET_KAPTION_RESPONSE_POLICY_METRICS, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
        fetchingMetrics: false,
      });
    }
  },

  async getMissed({ commit }, params = {}) {
    commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
      fetchingMissed: true,
    });
    try {
      const response = await kaptionResponsePoliciesAPI.getMissed(params);
      commit(types.default.SET_KAPTION_RESPONSE_POLICY_MISSED, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG, {
        fetchingMissed: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_KAPTION_RESPONSE_POLICY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_KAPTION_RESPONSE_POLICIES]: MutationHelpers.set,
  [types.default.ADD_KAPTION_RESPONSE_POLICY]: MutationHelpers.create,
  [types.default.UPDATE_KAPTION_RESPONSE_POLICY]: MutationHelpers.update,
  [types.default.SET_KAPTION_RESPONSE_POLICY_METRICS](_state, data) {
    _state.metrics = data;
  },
  [types.default.SET_KAPTION_RESPONSE_POLICY_MISSED](_state, data) {
    _state.missed = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
